import type { CurrentAccountDetails } from "./use-current-account";

export function isNewUiResolutionLoading(
  account: CurrentAccountDetails | undefined,
  flag: boolean | undefined,
): boolean {
  return !account || (!account["new-manager-global"] && flag === undefined);
}
